const MintForm = ({
  imgMint,
  imgBadge,
  data
}) => {

  const {
    title,
    titleHighlight,
    mintingForm,
    nftCategoryTitle,
    nftCategory,
    subscribe__btn
  } = data

  return (
      <section className="minting-section sect-p-80">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="bestArtists__header">
              <h2 className="mb-5">{title} <span className="highlight">{titleHighlight}</span></h2>
              <form action method="POST" className="minting-form">
                {mintingForm && mintingForm.map((item , key) => (
                  <div className="form-group" key={key}>
                    <label>{item.title}</label>
                    <input type={item.type} className="form-control" id={item.ID} placeholder={item.placeholder} />
                  </div>
                ))}
                <div className="form-group">
                  <textarea type="text" rows={3} className="form-control" id="item-desc" placeholder="Enter NFT Description" defaultValue={""} />
                </div>
                <div className="form-group">
                  <label>{nftCategoryTitle}</label>
                  <select name="cars" id="category" className="nft-category">
                    {nftCategory && nftCategory.map((item , key) => (
                      <option key={key} value={item.val}>{item.text}</option>
                    ))}
                  </select>
                </div>
                <button type="submit" className="subscribe__btn">{subscribe__btn}</button>
              </form>
            </div>
          </div>
          <div className="col-md-6">
            <div className="mint-wrapper">
              <img className="mint-img mt-s" loading="lazy" data-src={imgMint} alt="astronauta 1 NFT" />
              <img loading="lazy" data-src={imgBadge} alt="Emblema Rocket" className="badge-img" />
            </div>
          </div>
        </div>
      </section>
  );
}

export default MintForm;